import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer__container">
                <p>
                    © {new Date().getFullYear()} High Land Co., Ltd. All rights reserved.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
